import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const AccreditationSection = ({ accreditations }) => {
  return (
    <div className="bg-card rounded-lg border border-border p-4 md:p-5 lg:p-6">
      <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground mb-4 md:mb-5 flex items-center gap-2">
        <Icon name="Award" size={24} color="var(--color-primary)" />
        Accreditations & Certifications
      </h3>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5 lg:gap-6 mb-6 md:mb-8">
        {accreditations?.logos?.map((accreditation, index) => (
          <div
            key={index}
            className="flex flex-col items-center justify-center p-4 md:p-5 bg-background rounded-lg border border-border hover:shadow-warm transition-smooth"
          >
            <div className="w-16 h-16 md:w-20 md:h-20 mb-2 md:mb-3">
              <Image
                src={accreditation?.logo}
                alt={accreditation?.logoAlt}
                className="w-full h-full object-contain"
              />
            </div>
            <p className="text-xs md:text-sm text-center text-foreground font-caption font-medium">
              {accreditation?.name}
            </p>
          </div>
        ))}
      </div>
      <div className="space-y-3 md:space-y-4">
        <h4 className="text-base md:text-lg font-heading font-semibold text-foreground">
          Recognition & Partnerships
        </h4>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 md:gap-4">
          {accreditations?.recognitions?.map((recognition, index) => (
            <div key={index} className="flex items-start gap-3 p-3 md:p-4 bg-muted/50 rounded-lg">
              <Icon name="CheckCircle" size={20} color="var(--color-success)" />
              <div className="flex-1 min-w-0">
                <p className="text-sm md:text-base font-medium text-foreground mb-1">
                  {recognition?.title}
                </p>
                <p className="text-xs md:text-sm text-muted-foreground font-caption">
                  {recognition?.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AccreditationSection;